import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import CreatePlan from "./CreatePlan";
import SubscriptionCustom from "./SubscriptionCustom";
import SubscriptionTopUp from "./SubscriptionTopUp";

function AllSubscriptions() {
  return (
    <div className="contentAdmin bg-adminbg rounded p-4">
      <div
        className=" my-5 rounded-md"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <Tabs className="flex">
          <TabList className="flex flex-wrap">
            <Tab className="shrink-0">Admin Subscriptions</Tab>
            <Tab>Admin Subscriptions Custom</Tab>
            <Tab>Admin Subscriptions TopUp</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <CreatePlan />
            </TabPanel>
            <TabPanel>
              <SubscriptionCustom />
            </TabPanel>
            <TabPanel>
              <SubscriptionTopUp />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
}

export default AllSubscriptions;
